function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 170.663,
  height: 512
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg122Afghanistan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), _ref2, /*#__PURE__*/React.createElement("rect", {
    x: 341.337,
    style: {
      fill: "#496E2D"
    },
    width: 170.663,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,183.652c-39.956,0-72.348,32.392-72.348,72.348s32.392,72.348,72.348,72.348   s72.348-32.392,72.348-72.348S295.956,183.652,256,183.652z M256,301.217c-24.973,0-45.217-20.244-45.217-45.217   s20.244-45.217,45.217-45.217s45.217,20.244,45.217,45.217S280.973,301.217,256,301.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,228.87c-9.99,0-18.087,8.097-18.087,18.087v27.13h36.174v-27.13   C274.087,236.967,265.99,228.87,256,228.87z"
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg122Afghanistan);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxyZWN0IHdpZHRoPSIxNzAuNjYzIiBoZWlnaHQ9IjUxMiIvPgo8cmVjdCB4PSIzNDEuMzM3IiBzdHlsZT0iZmlsbDojNDk2RTJEOyIgd2lkdGg9IjE3MC42NjMiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGREE0NDsiIGQ9Ik0yNTYsMTgzLjY1MmMtMzkuOTU2LDAtNzIuMzQ4LDMyLjM5Mi03Mi4zNDgsNzIuMzQ4czMyLjM5Miw3Mi4zNDgsNzIuMzQ4LDcyLjM0OCAgIHM3Mi4zNDgtMzIuMzkyLDcyLjM0OC03Mi4zNDhTMjk1Ljk1NiwxODMuNjUyLDI1NiwxODMuNjUyeiBNMjU2LDMwMS4yMTdjLTI0Ljk3MywwLTQ1LjIxNy0yMC4yNDQtNDUuMjE3LTQ1LjIxNyAgIHMyMC4yNDQtNDUuMjE3LDQ1LjIxNy00NS4yMTdzNDUuMjE3LDIwLjI0NCw0NS4yMTcsNDUuMjE3UzI4MC45NzMsMzAxLjIxNywyNTYsMzAxLjIxN3oiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBkPSJNMjU2LDIyOC44N2MtOS45OSwwLTE4LjA4Nyw4LjA5Ny0xOC4wODcsMTguMDg3djI3LjEzaDM2LjE3NHYtMjcuMTMgICBDMjc0LjA4NywyMzYuOTY3LDI2NS45OSwyMjguODcsMjU2LDIyOC44N3oiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };